import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'Components';
import Heading from 'LearningManager/components/Heading';
import ConfigureSettingsCard from 'LearningManager/components/Review/ConfigureSettingsCard';
import { useStepper } from 'LearningManager/hooks/Stepper.context';
import styles from 'LearningManager/styles/CustomSetup.module.scss';

const orderingItems = [
	{
		id: 1,
		path: 'learning.createAssignment.review.ordering.basic',
		learnerGroup: 'learning.createAssignment.review.learnerGroups.staff'
	},
	{
		id: 2,
		path: 'learning.createAssignment.review.ordering.basicIntermediate',
		learnerGroup: 'learning.createAssignment.review.learnerGroups.managers'
	},
	{
		id: 3,
		path: 'learning.createAssignment.review.ordering.basicIntermediateAdvanced',
		learnerGroup:
			'learning.createAssignment.review.learnerGroups.leadershipIT'
	}
];

const Review: React.FC = () => {
	const { t } = useTranslation();
	const {
		draft: { configure }
	} = useStepper();

	return (
		<div id="lms-ca-quick-review" className={styles.review}>
			<Heading
				title={t('learning.createAssignment.review.title')}
				subHeading={t('learning.createAssignment.review.subHeading')}
			/>

			<div
				id="lms-ca-quick-review-ordering"
				className={styles.reviewSection}
			>
				<div className={styles.reviewSectionTitle}>
					{t('learning.createAssignment.review.ordering.title')}
				</div>
				<div className={styles.courseList}>
					{orderingItems.map((item) => (
						<div
							key={item.id}
							id={`lms-ca-quick-review-ordering-item-${item.id}`}
							className={styles.courseItem}
						>
							<Icon
								type="roleOptIcon"
								role="img"
								className={styles.blueIcon}
							/>
							<div className={styles.courseItemRight}>
								<div className={styles.courseLabel}>
									{t(item.path)}
								</div>
								<div className={styles.infoTag}>
									{t(item.learnerGroup)}
								</div>
							</div>
						</div>
					))}
				</div>
			</div>

			<div
				id="lms-ca-quick-review-audience"
				className={styles.reviewSection}
			>
				<div className={styles.reviewSectionTitle}>
					{t('learning.createAssignment.review.audience.title')}
				</div>
				<div className={styles.summaryCard}>
					<div>
						<div className={styles.mutedLabel}>
							{t('learning.createAssignment.review.audience.assignedLearners')}
						</div>
						<div className={styles.summaryValue}>
							{t('learning.createAssignment.review.audience.role')}
						</div>
					</div>
					<div>
						<div className={styles.mutedLabel}>
							{t('learning.createAssignment.review.audience.roles')}
						</div>
						<div className={styles.summaryValue}>
							{t('learning.createAssignment.review.audience.roleValues')}
						</div>
					</div>
				</div>
			</div>

			<div
				id="lms-ca-quick-review-configure"
				className={styles.reviewSection}
			>
				<div className={styles.reviewSectionTitle}>
					{t('learning.createAssignment.review.configureSettings')}
				</div>
				<ConfigureSettingsCard configure={configure} />
			</div>
		</div>
	);
};

export default Review;